var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoTasks = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 71,
  height: 83,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#no_tasks_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 37.906,
  height: 49.23,
  x: 16.424,
  y: 12.955,
  fill: "url(#no_tasks_svg__b)",
  rx: 3.818
}), /*#__PURE__*/React.createElement("rect", {
  width: 40.451,
  height: 51.775,
  x: 15.152,
  y: 11.682,
  stroke: "#fff",
  strokeWidth: 2.545,
  rx: 5.09
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#867AF2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.703,
  d: "M41.013 37.117h-.96M41.671 34.353h-1.555M42.33 31.587h-1.944M26.252 39.562h4.044a.57.57 0 0 0 .56-.584V28.745a.57.57 0 0 0-.56-.584h-4.044z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#867AF2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.703,
  d: "M30.857 38.743c3.346.529 6.724.8 10.109.815.756 0 1.465-.392 1.465-1.258a1.325 1.325 0 0 0-1.375-1.266h-.043.611a1.43 1.43 0 0 0 1.462-1.29 1.39 1.39 0 0 0-1.305-1.473h.498a1.44 1.44 0 0 0 1.465-1.293 1.39 1.39 0 0 0-1.309-1.47h.502a1.44 1.44 0 0 0 1.465-1.29 1.4 1.4 0 0 0-1.32-1.473h-5.274a.673.673 0 0 1-.682-.662.4.4 0 0 1 0-.141 6.6 6.6 0 0 0-.54-4.437 1.174 1.174 0 0 0-2.191.459 5.34 5.34 0 0 1-3.558 5.063M44.564 17.898c0 1.873-1.437 3.395-3.206 3.395M44.564 17.898c0 1.873 1.437 3.395 3.206 3.395M44.564 24.687c0-1.872 1.437-3.394 3.206-3.394"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#867AF2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.703,
  d: "M44.564 24.687c0-1.872-1.437-3.394-3.206-3.394"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m21.829 55.922 1.385 1.268 3.88-3.88M21.829 49.328l1.385 1.267 3.88-3.88"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M30.752 49.35H47.77M30.752 56.088H47.77"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "no_tasks_svg__b",
  x1: 16.424,
  x2: 54.33,
  y1: 37.57,
  y2: 37.57,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5DBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E8EDFF"
})), /*#__PURE__*/React.createElement("filter", {
  id: "no_tasks_svg__a",
  width: 70.755,
  height: 82.079,
  x: 0,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 3.47
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 6.94
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0.0352941 0 0 0 0 0.509804 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_25_1068"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_25_1068",
  result: "shape"
})))));
export default SvgNoTasks;